import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-matter" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "right-actions" }

import { computed, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import NcActions from '@nextcloud/vue/components/NcActions';
import NcActionButton from '@nextcloud/vue/components/NcActionButton';
import NcActionRadio from '@nextcloud/vue/components/NcActionRadio';
import NcActionSeparator from '@nextcloud/vue/components/NcActionSeparator';

import axios from '@nextcloud/axios';

import AlbumCreateModal from '@components/modal/AlbumCreateModal.vue';
import AlbumDeleteModal from '@components/modal/AlbumDeleteModal.vue';

import { downloadWithHandle } from '@services/dav';
import { API } from '@services/API';
import { windowDims } from '@services/viewport';
import { config, setConfig } from '@services/user-config';
import * as utils from '@services/utils/common';
import { constants } from '@services/constants';
import { t } from '@services/l10n';

import BackIcon from 'vue-material-design-icons/ArrowLeft.vue';
import DownloadIcon from 'vue-material-design-icons/Download.vue';
import EditIcon from 'vue-material-design-icons/Pencil.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import ShareIcon from 'vue-material-design-icons/ShareVariant.vue';
import SortIcon from 'vue-material-design-icons/SortVariant.vue';
import SlotAlphabeticalAIcon from 'vue-material-design-icons/SortAlphabeticalAscending.vue';
import SlotAlphabeticalDIcon from 'vue-material-design-icons/SortAlphabeticalDescending.vue';
import SortDateAIcon from 'vue-material-design-icons/SortCalendarAscending.vue';
import SortDateDIcon from 'vue-material-design-icons/SortCalendarDescending.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AlbumTopMatter',
},
  __name: 'AlbumTopMatter',
  setup(__props) {



const route = useRoute();
const router = useRouter();

const createModal = useTemplateRef<InstanceType<typeof AlbumCreateModal>>('createModal');
const deleteModal = useTemplateRef<InstanceType<typeof AlbumDeleteModal>>('deleteModal');

const isAlbumList = computed((): boolean => {
  return !route.params.name?.toString();
});

const canEditAlbum = computed((): boolean => {
  return !isAlbumList.value && route.params.user?.toString() === utils.uid;
});

const name = computed((): string => {
  // Album name is displayed in the dynamic top matter (timeline)
  return isAlbumList.value ? t('memories', 'Albums') : String();
});

const isDateSort = computed((): boolean => {
  return (
    !!(config.album_list_sort & constants.ALBUM_SORT_FLAGS.CREATED) ||
    !!(config.album_list_sort & constants.ALBUM_SORT_FLAGS.LAST_UPDATE)
  );
});

const isDescending = computed((): boolean => {
  return !!(config.album_list_sort & constants.ALBUM_SORT_FLAGS.DESCENDING);
});

const sortField = computed((): string => {
  if (config.album_list_sort & constants.ALBUM_SORT_FLAGS.CREATED) return 'created';
  if (config.album_list_sort & constants.ALBUM_SORT_FLAGS.NAME) return 'name';
  return 'last_update';
});

const sortDir = computed((): string => {
  return isDescending.value ? 'desc' : 'asc';
});

function back() {
  router.go(-1);
}

function openShareModal() {
  _m.modals.albumShare(route.params.user?.toString(), route.params.name?.toString());
}

async function downloadAlbum() {
  const res = await axios.post(API.ALBUM_DOWNLOAD(route.params.user?.toString(), route.params.name?.toString()));
  if (res.status === 200 && res.data.handle) {
    downloadWithHandle(res.data.handle, route.params.name?.toString());
  }
}

/** Set sort choice */
function changeSort(flag: number) {
  const dir = config.album_list_sort & constants.ALBUM_SORT_FLAGS.DESCENDING;
  setConfig('album_list_sort', flag | dir);
}

/** Set sort direction */
function setDescending(val: boolean) {
  let sort = config.album_list_sort;
  if (val) {
    sort |= constants.ALBUM_SORT_FLAGS.DESCENDING;
  } else {
    sort &= ~constants.ALBUM_SORT_FLAGS.DESCENDING;
  }
  setConfig('album_list_sort', sort);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isAlbumList.value)
      ? (_openBlock(), _createBlock(_unref(NcActions), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(name.value), 1),
    _createElementVNode("div", _hoisted_3, [
      (isAlbumList.value)
        ? (_openBlock(), _createBlock(_unref(NcActions), {
            key: 0,
            title: _unref(t)('memories', 'Sorting order'),
            forceMenu: true
          }, {
            icon: _withCtx(() => [
              (isDateSort.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (isDescending.value)
                      ? (_openBlock(), _createBlock(SortDateDIcon, {
                          key: 0,
                          size: 20
                        }))
                      : (_openBlock(), _createBlock(SortDateAIcon, {
                          key: 1,
                          size: 20
                        }))
                  ], 64))
                : (_unref(config).album_list_sort & _unref(constants).ALBUM_SORT_FLAGS.NAME)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (isDescending.value)
                        ? (_openBlock(), _createBlock(SlotAlphabeticalDIcon, {
                            key: 0,
                            size: 20
                          }))
                        : (_openBlock(), _createBlock(SlotAlphabeticalAIcon, {
                            key: 1,
                            size: 20
                          }))
                    ], 64))
                  : (_openBlock(), _createBlock(SortIcon, {
                      key: 2,
                      size: 20
                    }))
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(NcActionRadio), {
                name: "sort",
                "aria-label": _unref(t)('memories', 'Last updated'),
                "model-value": sortField.value,
                value: "last_update",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (changeSort(_unref(constants).ALBUM_SORT_FLAGS.LAST_UPDATE))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Last updated')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_unref(NcActionRadio), {
                name: "sort",
                "aria-label": _unref(t)('memories', 'Creation date'),
                "model-value": sortField.value,
                value: "created",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (changeSort(_unref(constants).ALBUM_SORT_FLAGS.CREATED))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Creation date')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_unref(NcActionRadio), {
                name: "sort",
                "aria-label": _unref(t)('memories', 'Album name'),
                "model-value": sortField.value,
                value: "name",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (changeSort(_unref(constants).ALBUM_SORT_FLAGS.NAME))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Album name')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_unref(NcActionSeparator)),
              _createVNode(_unref(NcActionRadio), {
                name: "sort-dir",
                "aria-label": isDateSort.value ? _unref(t)('memories', 'Oldest first') : _unref(t)('memories', 'Ascending'),
                "model-value": sortDir.value,
                value: "asc",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (setDescending(false))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDateSort.value ? _unref(t)('memories', 'Oldest first') : _unref(t)('memories', 'Ascending')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_unref(NcActionRadio), {
                name: "sort-dir",
                "aria-label": isDateSort.value ? _unref(t)('memories', 'Newest first') : _unref(t)('memories', 'Descending'),
                "model-value": sortDir.value,
                value: "desc",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (setDescending(true))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(isDateSort.value ? _unref(t)('memories', 'Newest first') : _unref(t)('memories', 'Descending')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NcActions), {
        inline: _unref(windowDims).isMobile ? 1 : 3
      }, {
        default: _withCtx(() => [
          (isAlbumList.value)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 0,
                "aria-label": _unref(t)('memories', 'Create new album'),
                title: _unref(t)('memories', 'Create new album'),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (createModal.value?.open(false))),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(PlusIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Create new album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (canEditAlbum.value)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 1,
                "aria-label": _unref(t)('memories', 'Share album'),
                title: _unref(t)('memories', 'Share album'),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (openShareModal())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(ShareIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Share album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (!isAlbumList.value)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 2,
                "aria-label": _unref(t)('memories', 'Download album'),
                title: _unref(t)('memories', 'Download album'),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (downloadAlbum())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(DownloadIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Download album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (canEditAlbum.value)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 3,
                "aria-label": _unref(t)('memories', 'Edit album details'),
                title: _unref(t)('memories', 'Edit album details'),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (createModal.value?.open(true))),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(EditIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Edit album details')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (!isAlbumList.value)
            ? (_openBlock(), _createBlock(_unref(NcActionButton), {
                key: 4,
                "aria-label": _unref(t)('memories', 'Remove album'),
                title: _unref(t)('memories', 'Remove album'),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (deleteModal.value?.open())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(DeleteIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('memories', 'Remove album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["inline"])
    ]),
    _createVNode(AlbumCreateModal, {
      ref_key: "createModal",
      ref: createModal
    }, null, 512),
    _createVNode(AlbumDeleteModal, {
      ref_key: "deleteModal",
      ref: deleteModal
    }, null, 512)
  ]))
}
}

})